import * as React from "react";
import { Container } from "@grandvisionhq/elements";
import { StoreFinderProvider } from "@grandvisionhq/stores-v2";
import StoreFinderContainer from "../../../../StoreFinder/v3/components/StoreFinder/StoreFinderContainer.js";
const AppointmentLocation = ({ appointmentTypeId }) => /* @__PURE__ */ React.createElement(
  StoreFinderProvider,
  {
    googleMapsId: "google-maps-container",
    withUrlParams: true,
    isStoreFiltersButtonEnabled: true
  },
  /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(StoreFinderContainer, { appointmentTypeId }))
);
export {
  AppointmentLocation as default
};
//# sourceMappingURL=AppointmentLocation.js.map
